import { nativeAuthRequest } from "./native-auth";
import { queryClient } from "./query-client";

export function beginImpersonation() {
  void queryClient.cancelQueries();
  queryClient.clear();
  window.location.assign("/");
}
export async function stopImpersonation() {
  await nativeAuthRequest("admin/stop-impersonating", {});
  void queryClient.cancelQueries();
  queryClient.clear();
  window.location.assign("/admin");
}
